/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OpenVulnCountSnapshot } from './OpenVulnCountSnapshot';
import {
    OpenVulnCountSnapshotFromJSON,
    OpenVulnCountSnapshotFromJSONTyped,
    OpenVulnCountSnapshotToJSON,
    OpenVulnCountSnapshotToJSONTyped,
} from './OpenVulnCountSnapshot';

/**
 * 
 * @export
 * @interface BlastRadiusAssetDto
 */
export interface BlastRadiusAssetDto {
    /**
     * 
     * @type {string}
     * @memberof BlastRadiusAssetDto
     */
    assetGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof BlastRadiusAssetDto
     */
    assetClass?: string;
    /**
     * 
     * @type {string}
     * @memberof BlastRadiusAssetDto
     */
    hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof BlastRadiusAssetDto
     */
    imageDigest?: string;
    /**
     * 
     * @type {number}
     * @memberof BlastRadiusAssetDto
     */
    openFindingCount?: number;
    /**
     * 
     * @type {OpenVulnCountSnapshot}
     * @memberof BlastRadiusAssetDto
     */
    severityBreakdown?: OpenVulnCountSnapshot;
    /**
     * 
     * @type {number}
     * @memberof BlastRadiusAssetDto
     */
    materializedOpenVulnCount?: number;
}

/**
 * Check if a given object implements the BlastRadiusAssetDto interface.
 */
export function instanceOfBlastRadiusAssetDto(value: object): value is BlastRadiusAssetDto {
    return true;
}

export function BlastRadiusAssetDtoFromJSON(json: any): BlastRadiusAssetDto {
    return BlastRadiusAssetDtoFromJSONTyped(json, false);
}

export function BlastRadiusAssetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlastRadiusAssetDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetGoldenId': json['assetGoldenId'] == null ? undefined : json['assetGoldenId'],
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'imageDigest': json['imageDigest'] == null ? undefined : json['imageDigest'],
        'openFindingCount': json['openFindingCount'] == null ? undefined : json['openFindingCount'],
        'severityBreakdown': json['severityBreakdown'] == null ? undefined : OpenVulnCountSnapshotFromJSON(json['severityBreakdown']),
        'materializedOpenVulnCount': json['materializedOpenVulnCount'] == null ? undefined : json['materializedOpenVulnCount'],
    };
}

export function BlastRadiusAssetDtoToJSON(json: any): BlastRadiusAssetDto {
    return BlastRadiusAssetDtoToJSONTyped(json, false);
}

export function BlastRadiusAssetDtoToJSONTyped(value?: BlastRadiusAssetDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetGoldenId': value['assetGoldenId'],
        'assetClass': value['assetClass'],
        'hostname': value['hostname'],
        'imageDigest': value['imageDigest'],
        'openFindingCount': value['openFindingCount'],
        'severityBreakdown': OpenVulnCountSnapshotToJSON(value['severityBreakdown']),
        'materializedOpenVulnCount': value['materializedOpenVulnCount'],
    };
}

